module.exports = __webpack_public_path__ + "img/product_03.37443b84.png";